import { render, staticRenderFns } from "./TicketsReOpenDialog.vue?vue&type=template&id=59062aa8&"
import script from "./TicketsReOpenDialog.vue?vue&type=script&lang=js&"
export * from "./TicketsReOpenDialog.vue?vue&type=script&lang=js&"
import style0 from "./TicketsReOpenDialog.vue?vue&type=style&index=0&id=59062aa8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports